
import { Options, Vue } from 'vue-class-component';

const alertTypes = [
    'primary',
    'secondary',
    'success',
    'danger',
    'warning',
    'info',
    'light',
    'dark',
];

@Options({
    props: {
        type: {
            type: String,
            required: false,
            default: 'danger',
            validator(val: string) {
                return alertTypes.includes(val);
            }
        },

        message: {
            type: String,
            required: false,
        },

        small: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    methods: {

    },
    components: {

    },
})
export default class Alert extends Vue {
    type!: string
    message!: string
    small!: boolean
}
